var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNote = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 12,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#5C5F62",
  fillRule: "evenodd",
  d: "M2.2 6.7h5.6V5.3H2.2zm0 2.8h5.6V8.1H2.2zm0-5.6H5V2.5H2.2zM6.4.4H1.85C1.27.4.8.87.8 1.45v9.1c0 .58.47 1.05 1.05 1.05h6.3c.58 0 1.05-.47 1.05-1.05V3.2z",
  clipRule: "evenodd"
})));
export { SvgNote as ReactComponent };
export default __webpack_public_path__ + "static/media/note.18ac06ee.svg";